//@flow
import React from "react";
import {
  StyleSheet,
  Text,
  TouchableOpacity,
  Dimensions,
  View,
} from "react-native";

const { width } = Dimensions.get("window");

type Props = {
  onPress: () => mixed,
  text: string,
  disable: false,
  buttonPropStyle?: {},
  textPropStyle?: {},
};

const ModalButton = ({
  disable,
  onPress,
  text,
  buttonPropStyle,
  textPropStyle,
}: Props) => {
  let { buttonStyle, textStyle } = styles;
  buttonStyle = buttonPropStyle
    ? { ...buttonStyle, ...buttonPropStyle }
    : buttonStyle;
  textStyle = textPropStyle ? { ...textStyle, ...textPropStyle } : textStyle;

  const result = !disable ? (
    <TouchableOpacity onPress={onPress} style={buttonStyle}>
      <Text style={textStyle}>{text}</Text>
    </TouchableOpacity>
  ) : (
    <View style={buttonStyle}>
      <Text style={textStyle}>{text}</Text>
    </View>
  );
  return result;
};

const styles = {
  textStyle: {
    color: "white",
    fontSize: 18,
    fontWeight: "bold",
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 15,
    paddingRight: 15,
  },
  buttonStyle: {
    boxSizing: "border-box",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FFCB34",
    borderRadius: 10,
    shadowColor: "#000000",
    elevation: 2,
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowRadius: 10,
    shadowOpacity: 0.1,
  },
};

export { ModalButton };
